import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { UIButton } from 'app/components/ui';


const locales = {
    ru: {
        addMore: 'Добавить больше блюд',
        order: 'Оформить заказ',
    },
    en: {
        addMore: 'Add more',
        order: 'Make an order',
    },
};


export default function CheckoutLinks(props) {
    const {
        locale,
        isCheckoutEnabled,
        isLinkToMenuEnabled,
        period,
        periodVisibilityState = null,
    } = props;

    const { search } = window.location;
    const params = queryString.parse(search);
    const linkSearch = queryString.stringify({
        ...params,
        period,
        payment: 'online',
    });

    const hasLinkToMenu = isLinkToMenuEnabled && periodVisibilityState === 'visible';
    const hasLinkToBasket = !isCheckoutEnabled;
    const hasContent = hasLinkToMenu || hasLinkToBasket;

    if (!hasContent) return null;

    return (
        <div className="ny__set__display-all-dishes__container">
            {hasLinkToMenu && (
                <UIButton
                    elType="a"
                    href={`/menu/?${linkSearch}`}
                >
                    {locales[locale].addMore}
                </UIButton>
            )}
            {hasLinkToBasket && (
                <UIButton
                    elType="a"
                    href={`/basket/?${linkSearch}`}
                >
                    {locales[locale].order}
                </UIButton>
            )}
        </div>
    );
}

CheckoutLinks.propTypes = {
    locale: PropTypes.oneOf(['ru', 'en']).isRequired,
    isCheckoutEnabled: PropTypes.bool.isRequired,
    isLinkToMenuEnabled: PropTypes.bool.isRequired,
    period: PropTypes.string.isRequired,
    periodVisibilityState: PropTypes.string,
};
